import { Link } from "react-router-dom";

export function SchedulesEmptyState() {
  return (
    <div className="bg-surface border border-border-subtle rounded-lg p-10 text-center max-w-2xl mx-auto">
      <h2 className="text-base font-semibold text-white">No schedules yet</h2>
      <p className="text-sm text-text-muted mt-1.5 mb-5">
        Create one to import an Outlook calendar.
      </p>
      <Link
        to="/schedules/new"
        data-testid="empty-state-new-schedule"
        className="inline-flex items-center gap-1.5 bg-brand hover:bg-brand-hover text-white text-sm font-semibold rounded-md px-4 py-2"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
        New Schedule
      </Link>
    </div>
  );
}
